import { useFormikContext } from 'formik';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { PercentageFieldText } from 'src/components/mui-overrides/Percentage';

interface Props {
  disabled?: boolean;
}

export const IssueFundingFloorPercentageField: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();
  const formik = useFormikContext();

  return (
    <PercentageFieldText
      disabled={disabled}
      label={t('dashboard.assets.addedit.investment.issuingdetails.fields.fundingfloor')}
      fieldName="investmentDetails.issueFundingFloor"
      formik={formik}
    />
  );
};
